import StoreSettingType from 'constants/StoreSettingType';
import { getDiffFromNow } from 'shared/utils/date-time';
import OrdersUtils from 'utils/OrdersUtils';
import { autoAcceptRepository as repository } from '../repositories';

import type { OrderResponseFromStatusV2 } from 'business/shared/infra';
import type { HasAutoacceptData } from 'shared/infra';
import type { StoreSettingResponse } from '../core/responses';

async function _getStoreSettings() {
  const { data } = await repository.getStoreSettings();
  const localData: HasAutoacceptData = {
    value: _transformValue(data),
    updated: new Date().toISOString(),
  };
  repository.setAutoAcceptStored(localData);
}

function _transformValue(settings: StoreSettingResponse) {
  for (const key in settings) {
    if (
      settings[key].some(
        setting => setting.day === StoreSettingType.AUTO_ACCEPT,
      )
    ) {
      return 1;
    }
  }
  return 0;
}

function isEnabled() {
  const data = repository.getAutoAcceptStored();
  if (!data) {
    return false;
  }
  return data.value === 1;
}

function sync() {
  const storedData = repository.getAutoAcceptStored();
  if (storedData) {
    const { hours } = getDiffFromNow(storedData.updated);
    if (hours >= 24) {
      _getStoreSettings();
    }
    return;
  }
  _getStoreSettings();
}

function saveValue(hasAutoAccept: boolean) {
  const localData: HasAutoacceptData = {
    value: hasAutoAccept ? 1 : 0,
    updated: new Date().toISOString(),
  };
  repository.setAutoAcceptStored(localData);
}

function filterHighlightOrders(orders: OrderResponseFromStatusV2[]) {
  if (orders == null || !isEnabled()) {
    return [];
  }
  const cookingOrders = orders.filter(val =>
    OrdersUtils.isBeingCooking(val.partner_order_state),
  );
  return filterCookingOrders(cookingOrders);
}

function filterCookingOrders(orders: OrderResponseFromStatusV2[]) {
  return orders.filter(val => {
    const { sec } = getDiffFromNow(val.cooking_time_started_at);
    return sec <= 15;
  });
}

export const autoAcceptService = {
  isEnabled,
  sync,
  saveValue,
  filterHighlightOrders,
  filterCookingOrders,
} as const;
